import React from 'react'
import ClientConversation from '../ClientDashboard/components/ClientConversation'
import { useIsConversationsActive } from '../../../hooks/featureChecks'

function ConversationButton (props) {
  const isConversationsActive = useIsConversationsActive(props)

  if (!isConversationsActive) {
    return null
  }

  return (
    <ClientConversation {...props} />
  )
}

export default ConversationButton
